export const scrollToSection = (id: string) => {
  if (typeof window === 'undefined') return

  const element = document.getElementById(id)
  if (element) {
    const topPosition =
      element.getBoundingClientRect().top + window.scrollY - 220
    window.scrollTo({ top: topPosition, behavior: 'smooth' })
  }
}

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
